const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPainMedicine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M15.543,24.602H5.93 c-0.895,0-1.621-0.726-1.621-1.621V6.669c0-0.895,0.726-1.621,1.621-1.621h9.613c0.895,0,1.621,0.726,1.621,1.621V22.98 C17.164,23.876,16.438,24.602,15.543,24.602z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.019,
    y: 6.721,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 9.268,
    height: 11.264
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.416,
    y: 18.864,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.561,
    height: 1.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.471,
    y: 18.864,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 2.365,
    height: 0.842
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.471,
    y: 22.318,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 2.365,
    height: 0.842
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.718,
    y: 20.626,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.872,
    height: 0.771
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.416,
    y: 22.012,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.561,
    height: 1.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.215,
    y: 18.864,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.561,
    height: 1.148
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.215,
    y: 22.012,
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.561,
    height: 1.148
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 6.019,
    y1: 8.668,
    x2: 15.288,
    y2: 8.668
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 6.019,
    y1: 12.723,
    x2: 15.288,
    y2: 12.723
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 6.019,
    y1: 16.295,
    x2: 15.288,
    y2: 16.295
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 9.505,
    y1: 6.721,
    x2: 9.505,
    y2: 8.668
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 13.174,
    y1: 6.721,
    x2: 13.174,
    y2: 8.668
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 6.742,
    y1: 17.145,
    x2: 7.98,
    y2: 17.145
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 13.416,
    y1: 17.145,
    x2: 14.653,
    y2: 17.145
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M22.451,22.19l2.975-3.043 c0.913-2.028-0.338-3.245-0.338-3.245c-1.656-1.826-3.685-0.879-3.685-0.879l-7.606,7.403c0,0-1.386,1.758,0.27,3.685 c0,0,0.913,1.149,2.873,0.913"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 17.448,
    y1: 18.844,
    x2: 20.964,
    y2: 22.359
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M14.989,22.461c0,0-1.749,1.699,0.101,3.195"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M16.84,24.59v2.552 c0,1.204,2.429,2.18,5.426,2.18c2.997,0,5.426-0.976,5.426-2.18v-2.704"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M27.691,24.438 c0,1.204-2.429,2.18-5.426,2.18c-2.997,0-5.426-0.976-5.426-2.18c0-1.204,2.429-2.18,5.426-2.18 C25.262,22.258,27.691,23.234,27.691,24.438z"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 20.11,
    y1: 26.416,
    x2: 24.573,
    y2: 22.486
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M25.159,9.142 c0,2.515-2.039,4.555-4.555,4.555c-2.515,0-4.555-2.039-4.555-4.555c0-2.515,2.039-4.555,4.555-4.555 C23.119,4.588,25.159,6.627,25.159,9.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.337,9.142 c0,2.062-1.671,3.733-3.733,3.733c-2.061,0-3.733-1.671-3.733-3.733c0-2.062,1.671-3.733,3.733-3.733 C22.665,5.41,24.337,7.081,24.337,9.142z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 20.604,
    cy: 9.142,
    r: 2.799
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "22.102,8.532 21.214,8.532  21.214,7.645 19.994,7.645 19.994,8.532 19.106,8.532 19.106,9.752 19.994,9.752 19.994,10.64 21.214,10.64 21.214,9.752  22.102,9.752  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889"
    },
    d: "M8.318,9.909h0.817c0.178,0,0.311,0.042,0.4,0.127c0.088,0.085,0.133,0.206,0.133,0.362 c0,0.161-0.048,0.286-0.145,0.376c-0.096,0.09-0.244,0.136-0.442,0.136h-0.27v0.59H8.318V9.909z M8.812,10.587h0.121 c0.095,0,0.162-0.017,0.2-0.05c0.039-0.033,0.058-0.075,0.058-0.126c0-0.05-0.017-0.092-0.05-0.127 c-0.034-0.035-0.096-0.052-0.188-0.052h-0.14V10.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889"
    },
    d: "M10.985,10.849l0.431,0.13c-0.029,0.121-0.074,0.222-0.137,0.303 c-0.062,0.081-0.139,0.142-0.231,0.184c-0.092,0.041-0.21,0.062-0.353,0.062c-0.173,0-0.314-0.025-0.424-0.076 c-0.109-0.05-0.204-0.139-0.284-0.265c-0.08-0.126-0.119-0.289-0.119-0.486c0-0.263,0.07-0.465,0.21-0.607 c0.14-0.141,0.338-0.212,0.594-0.212c0.2,0,0.358,0.041,0.473,0.122c0.115,0.081,0.2,0.206,0.255,0.373l-0.434,0.097 c-0.015-0.048-0.031-0.084-0.048-0.106c-0.027-0.038-0.061-0.066-0.101-0.086c-0.04-0.021-0.084-0.031-0.134-0.031 c-0.111,0-0.197,0.045-0.256,0.135c-0.045,0.066-0.067,0.171-0.067,0.313c0,0.176,0.027,0.297,0.08,0.363 c0.054,0.065,0.129,0.098,0.226,0.098c0.094,0,0.165-0.026,0.213-0.079C10.928,11.026,10.963,10.949,10.985,10.849z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889"
    },
    d: "M12.632,11.237h-0.558L11.997,11.5h-0.502l0.598-1.591h0.537l0.598,1.591h-0.515L12.632,11.237z  M12.53,10.893l-0.176-0.572l-0.174,0.572H12.53z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainMedicine);
export default __webpack_public_path__ + "static/media/pain_medicine.5252e4cbf8c5547d2cbe4860b6d64e30.svg";
export { ForwardRef as ReactComponent };